/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-box': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M12.5 13.125h-5c-.69 0-1.25-.56-1.25-1.25v-1.25c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25v1.25c0 .69-.56 1.25-1.25 1.25zm-5-2.5v1.25h5v-1.25h-5zm10-8.125h-15c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25v10c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-10c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm-1.25 15H3.75v-10h12.5v10zM17.5 6.25h-15v-2.5h15v2.5z"/>'
  }
})
